import React, { Component } from 'react';
import { Form, Button, Container, Message } from 'semantic-ui-react';
import { LocaleContext } from '../locale-context';
import * as emailjs from 'emailjs-com';
const translations = {
    en: {
        firstName: 'First Name',
        lastName: 'Last Name',
        phone: 'Phone Number',
        subject: 'Subject',
        message: 'Message',
        sent: 'Email Sent',
        sentMessage: 'We will reply to your email as soon as possible.',
        notSent: 'Email not sent!',
        notSentMessage: 'Please try again later.',
        notSentWarning: 'Please verify the email address',
        button: 'Send'
    },
    ro: {
        firstName: 'Nume',
        lastName: 'Prenume',
        phone: 'Telefon',
        subject: 'Subiect',
        message: 'Mesaj',
        sent: 'Mesaj Trimis',
        sentMessage: 'Va vom raspunde la mesaj cat de repede vom putea.',
        notSent: 'Mesajul nu a fost trimis!',
        notSentMessage: 'Va rugam incercati mai tarziu.',
        notSentWarning: 'Va rugam verificati adresa de email!',
        button: 'Trimite'
    }
};

class Contact extends Component {
    state = {
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        subject: '',
        message: '',
        errorText: '',
        submitSuccess: false,
        submitError: false,
        submitWarning: false
    };

    handleChange = (e, { name, value }) => this.setState({ [name]: value });
    onSubmit = () => {
        const {
            firstName,
            lastName,
            subject,
            message,
            email,
            phone
        } = this.state;

        const templateParams = {
            from_name: this.state.email,
            person_name: `${this.state.firstName} - ${this.state.lastName}`,
            to_name: 'bogdan@progresscoaching.ro',
            message_html: this.state.message,
            subject_html: this.state.subject,
            ejs_dashboard__test_template: true,
            phone_no: this.state.phone
        };

        if (!email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
            this.setState({
                submitWarning: true
            });
        } else {
            emailjs
                .send(
                    'gmail',
                    'template_XoVQXD63',
                    templateParams,
                    'user_ZPYwaHgnmuIrT1VMHVQVz'
                )
                .then(
                    response => {
                        this.setState({
                            firstName: '',
                            lastName: '',
                            phone: '',
                            email: '',
                            subject: '',
                            message: '',
                            submitError: false,
                            submitSuccess: true,
                            submitWarning: false
                        });
                        console.log('SUCCESS!', response.status, response.text);
                    },
                    err => {
                        this.setState({
                            firstName: '',
                            lastName: '',
                            phone: '',
                            email: '',
                            subject: '',
                            message: '',
                            submitError: true,
                            submitSuccess: false,
                            submitWarning: false
                        });
                        console.log('FAILED...', err);
                    }
                );
        }
    };

    render() {
        const {
            firstName,
            lastName,
            phone,
            message,
            subject,
            email,
            submitError,
            submitSuccess,
            submitWarning
        } = this.state;

        const { language } = this.props;
        const strings = translations[language];

        return (
            <React.Fragment>
                <section className="cover cover-contact">
                    <div className="text-box contact-form">
                        <h1 className="heading-primary">
                            <span className="heading-primary-main">
                                Contact
                            </span>
                        </h1>
                        <Form
                            className="contact-form testimonial-component"
                            onSubmit={this.onSubmit}
                            warning={submitWarning}
                            success={submitSuccess}
                            error={submitError}
                        >
                            <Form.Group widths="equal">
                                <Form.Input
                                    label={strings.firstName}
                                    placeholder={strings.firstName}
                                    width={6}
                                    value={firstName}
                                    name="firstName"
                                    onChange={this.handleChange}
                                    required
                                />
                                <Form.Input
                                    label={strings.lastName}
                                    placeholder={strings.lastName}
                                    width={6}
                                    value={lastName}
                                    name="lastName"
                                    onChange={this.handleChange}
                                    required
                                />
                            </Form.Group>

                            <Form.Group>
                                <Form.Input
                                    label="Email"
                                    placeholder="Email"
                                    width={8}
                                    name="email"
                                    value={email}
                                    onChange={this.handleChange}
                                    required
                                />
                                <Form.Input
                                    label={strings.phone}
                                    placeholder={strings.phone}
                                    width={8}
                                    name="phone"
                                    value={phone}
                                    onChange={this.handleChange}
                                    required
                                />
                            </Form.Group>

                            <Form.Group>
                                <Form.Input
                                    placeholder={strings.subject}
                                    width={16}
                                    name="subject"
                                    value={subject}
                                    onChange={this.handleChange}
                                    required
                                />
                            </Form.Group>

                            <Form.Group>
                                <Form.TextArea
                                    placeholder={strings.message}
                                    width={16}
                                    name="message"
                                    value={message}
                                    onChange={this.handleChange}
                                    required
                                />
                            </Form.Group>

                            <Message
                                success
                                header={strings.sent}
                                content={strings.sentMessage}
                            />
                            <Message
                                error
                                header={strings.notSent}
                                content={strings.notSentMessage}
                            />
                            <Message
                                warning
                                header={strings.notSent}
                                content={strings.notSentWarning}
                            />

                            <Form.Button
                                color="green"
                                fluid
                                size="huge"
                                content={strings.button}
                            />
                        </Form>
                    </div>
                </section>
            </React.Fragment>
        );
    }
}

const TranslatedComponent = props => (
    <LocaleContext>
        {value => <Contact language={value} {...props} />}
    </LocaleContext>
);

export default TranslatedComponent;



// WEBPACK FOOTER //
// ./src/components/Contact.js